export default __webpack_public_path__ + "static/media/kb-image.57d58ac1.jpg";